import { render, staticRenderFns } from "./JourneyMetrics.vue?vue&type=template&id=16289e21&scoped=true&"
import script from "./JourneyMetrics.vue?vue&type=script&lang=js&"
export * from "./JourneyMetrics.vue?vue&type=script&lang=js&"
import style0 from "./JourneyMetrics.vue?vue&type=style&index=0&id=16289e21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16289e21",
  null
  
)

export default component.exports